import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { DollarSign } from 'lucide-react';

const formatCurrency = (num) => {
  if (num === undefined || num === null) return '-';
  return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON' }).format(num);
};

const COLORS = ['#6366f1', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6'];

export const PricesTab = ({ priceHistory }) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Evolutie Preturi</CardTitle>
      </CardHeader>
      <CardContent>
        {priceHistory?.timeline?.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={priceHistory.timeline}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="label" tick={{ fontSize: 11 }} stroke="#64748b" />
              <YAxis tick={{ fontSize: 11 }} stroke="#64748b" tickFormatter={(v) => `${v} RON`} />
              <Tooltip
                contentStyle={{ borderRadius: 8, border: '1px solid #e2e8f0' }}
                formatter={(value) => value ? [formatCurrency(value), 'Pret'] : ['-', 'Pret']}
              />
              <Legend />
              {priceHistory?.suppliers?.slice(0, 5).map((sup, idx) => (
                <Line
                  key={sup.supplier_id}
                  type="monotone"
                  dataKey={`price_${sup.supplier_id}`}
                  name={sup.supplier_name}
                  stroke={COLORS[idx % 5]}
                  strokeWidth={2}
                  dot={{ r: 2 }}
                  connectNulls
                />
              ))}
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-64 flex items-center justify-center text-slate-400">
            Nu exista istoric de preturi
          </div>
        )}
      </CardContent>
    </Card>
  );
};
